import axios from "../../../../axios";
import React, { useContext, useEffect, useState } from "react";
import "./channelRequest.css";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios1 from "axios";
import { IP } from "../../../../internalServer";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CreatePostFirst from "../../../Open_community/Create_Post_screen/CreatePostFirst";
import DeletePost from "./DeletePost";
import RequestContext from "../../../Open_community/Create_channel/View_Channel_Screen/View_First_Screen/requestContext";
import { useLocation } from "react-router-dom";
import assets from "../../../../assets/assets";

const ChannelRequest = ({
  requestPost,
  setPostRequestCount,
  setRejectedPostCount,
  setPostStatusChanged,
  postStatusChanged,
  setInProgress,
  setRequestList,
  setFilter,
  filter,
  getPostRequest
}) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [deleteClick, setDeleteClick] = useState(false);
  const [postEdit, setPostEdit] = useState(false);
  // const { communityId } = useParams();
  const { state } = useLocation()

  const handleSlideChange = (current) => {
    setCurrentSlide(current + 1);
  };

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    afterChange: handleSlideChange,
    arrows: true,
  };
  const currentuser = useSelector((state) => state.user.currentUser);
  const handelPostDelete = async () => {
    setInProgress(true);
    try {
      let res = await axios.delete(
        `/community/${state.communityId}/post/delete/${requestPost?.id}`,
        {
          data: { user_id: currentuser?.id },
        }
      );
      if (res) {
        setRequestList([]);
        setFilter({ ...filter, page: 1 });
        setPostRequestCount((prev) => prev - 1);
        setPostStatusChanged(!postStatusChanged);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //   const timeHelper = (a) => {
  //     const dateObj = new Date(a);
  //     const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  //     const localDate = new Date(dateObj - userOffset); // Convert to local time

  //     const day = localDate.getDate();
  //     const month = localDate.getMonth() + 1;
  //     const year = localDate.getFullYear();
  //     const hours = localDate.getHours();
  //     const minutes = localDate.getMinutes();
  //     const seconds = localDate.getSeconds();

  //     const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //     return outputDateString;
  // };


  const timeHelper = (a) => {
    const dateObj = moment.utc(a).toDate();
    const ISTDateString = moment(dateObj).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
    return ISTDateString;
  };

  const rejectedStyle = {
    color: "#F00",
    textAlign: "right",
    // fontFamily: "Open Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "18px",
  };

  return requestPost ? (
    <>
      {/* <div className="allPost_container"> */}
      <div className="p-0  request_channel_name_box ">
        <div className="gap-2 mt-1 flex">
          <div className="px-2 py-0 w-20 h-20">
            <img
              src={
                requestPost?.user_id?.profile_picture
                  ? IP + requestPost?.user_id?.profile_picture.replace(/^\./, "")
                  : requestPost?.user_id?.gender === "M"
                    ? requestPost?.user_id?.avatar_profile ? '/images/Boys/' + requestPost?.user_id?.avatar_profile + '.webp'
                      : "/images/Student_boy_pic.png"
                    : requestPost?.user_id?.gender === "F"
                      ? requestPost?.user_id?.avatar_profile ? '/images/Girls/' + requestPost?.user_id?.avatar_profile + '.webp'
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
              }
              alt="icon"
              className=""
              style={{ width: "55px", height: "55px", borderRadius: "15%", cursor: "pointer" }}
              key={requestPost?.avatar_profile}
              onError={(e) => {
                if (requestPost?.user_id?.gender === "M") {
                  e.target.src = requestPost?.user_id?.avatar_profile ? '/images/Boys/' + requestPost?.user_id?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                } else if (requestPost?.user_id?.gender === "F") {
                  e.target.src = requestPost?.user_id?.avatar_profile ? '/images/Girls/' + requestPost?.user_id?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                } else {
                  e.target.src = "/images/default image.png"
                }
              }}
            />
          </div>

          <div className="w-[90%] border-2 border-gray-300 px-3 py-2 rounded-lg">
            <div className="aaa">
              <div className=" d-flex justify-content-between ">
                <div>
                  <span className="request_channel_name">
                    {requestPost?.user_id?.name}
                    &nbsp;
                    {requestPost?.user_id?.standard?.name} -
                    {requestPost?.user_id?.section?.name}
                  </span>
                  {requestPost?.tags.length > 0 &&
                    requestPost?.tags.map((item, index) => (
                      <span
                        key={index}
                        className="related_postName mx-1  px-2 py-1"
                      >
                        {item}
                      </span>
                    ))}
                </div>
                {/* <img src="/images/three dot hr.svg" /> */}
                {requestPost?.status === "pending" ? (
                  <div className="under_review">Under Review</div>
                ) : requestPost?.status === "active" ? (
                  <div className="under_review" style={{ color: "#297333" }}>
                    Your Post
                  </div>
                ) : (
                  <div className="under_review" style={rejectedStyle}>
                    Declined.
                  </div>
                )}
              </div>

              <div className=" request_created_by mt-2">
                <div className="mb-1">{requestPost?.community_id?.community_name}</div>
                <div>{moment(timeHelper(requestPost?.created_at)).calendar({
                  sameDay: "[Today] h:mm a",
                  lastDay: "[Yesterday] h:mm a",
                  lastWeek: "DD MMM YYYY h:mm a",
                  sameElse: "DD MMM YYYY h:mm a",
                })}</div>
              </div>
            </div>
            {requestPost?.status === "rejected" && (
              <>
                <p
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                  }}
                  className="mt-2 font-semibold"
                >
                  {requestPost?.description}
                </p>

                {
                  requestPost?.post_image?.length > 0 && (
                    <div
                      className=" p-0 request_post_image_box"
                    >
                      <div className="slider_container">
                        <Slider {...settings}>
                          {requestPost?.post_image?.length > 0 && (
                            requestPost?.post_image?.map((item) => (
                              <img
                                src={`${IP + item}`}
                                className="request_post_image"
                                alt=""
                                onError={(e) => {
                                  e.target.src = "/images/no-image5.png"
                                }}
                              />
                            ))
                          )}
                        </Slider>
                        {requestPost?.post_image?.length > 1 && (
                          <span className="post_image_count d-flex align-items-center justify-content-center">
                            {currentSlide}/{requestPost?.post_image?.length}
                          </span>
                        )}
                      </div>
                    </div>
                  )
                }

              </>
            )}
            {requestPost?.status === "pending" && (
              <>
                <p
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                  }}
                  className="mt-2  font-semibold"
                >
                  {requestPost?.description}
                </p>
                {
                  requestPost?.post_image?.length > 0 && (
                    <div
                      className="p-0 request_post_image_box"
                    >
                      <div className="slider_container">
                        <Slider {...settings}>
                          {requestPost?.post_image?.length > 0 && (
                            requestPost?.post_image?.map((item) => (
                              <img
                                src={`${IP + item}`}
                                className="request_post_image"
                                alt=""
                                onError={(e) => {
                                  // e.target.src = assets.CommunityImg
                                  e.target.src = "/images/no-image5.png"
                                }}
                              />
                            ))
                          )}
                        </Slider>
                        {requestPost?.post_image?.length > 1 && (
                          <span className="post_image_count d-flex align-items-center justify-content-center">
                            {currentSlide}/{requestPost?.post_image?.length}
                          </span>
                        )}
                      </div>
                    </div>
                  )
                }
              </>
            )}
            {(requestPost?.status !== "active" || requestPost?.status === "rejected") && (
              <div className="accept_denie mt-4 mb-3 d-flex justify-content-center gap-sm-4 gap-3 flex-wrap ">
                <button
                  value="active"
                  className="btn btn-danger col-sm-5 request_accept_btn request_accept_btn1"
                  onClick={(e) => setPostEdit(true)}
                >
                  Edit
                </button>
                <button
                  value="rejected"
                  className="btn btn-danger col-sm-5  request_accept_btn"
                  onClick={(e) => setDeleteClick(true)}
                >
                  Delete
                </button>
              </div>
            )}
          </div>


          {/* {requestPost?.status === "rejected" && (
              <div className="accept_denie mt-4 mb-3 d-flex justify-content-center gap-sm-4 gap-3 flex-wrap ">
                <button
                  value="active"
                  className="btn btn-danger col-sm-5 request_accept_btn request_accept_btn1"
                  onClick={(e) => setPostEdit(true)}
                >
                  Edit
                </button>
                <button
                  value="rejected"
                  className="btn btn-danger col-sm-5  request_accept_btn"
                  onClick={(e) => setDeleteClick(true)}
                  >
                    Delete
                  </button>
                </div>
              )} */}
        </div>
      </div>

      {/* </div> */}
      {postEdit && (
        <CreatePostFirst
          editingMode={true}
          post={requestPost}
          setClickPost={setPostEdit}
          clickPost={postEdit}
          getPostRequest={getPostRequest}
        />
      )}

      {deleteClick && (
        <DeletePost
          setDelet1={setDeleteClick}
          communityId={state.communityId}
          post_id={requestPost?.id}
          getPostRequest={getPostRequest}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default ChannelRequest;
